import React from 'react';
import { useTranslation } from 'react-i18next';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';

interface IProps {
	disabled: boolean;
	onClick: () => void;
}

export const ResetButton: React.FC<IProps> = ({ disabled, onClick }) => {
	const { t } = useTranslation('listing');

	return (
		<NewButton
			variant="outline"
			size="small"
			icon={true}
			iconLeft={<Icon name={IconName.refresh} size="lg" />}
			disabled={disabled}
			ariaLabel={t('resetButton')}
			testId="ResetBtn"
			onClick={onClick}
		/>
	);
};
